export default __webpack_public_path__ + "static/media/back-cnt.d159b4c6.jpg";